import React, { ReactChild } from "react"
import { useRouter } from "next/router"
import { PageKey } from "~/models/Page"

/*
    フレーム生成用コンポーネント
    props
        className:クラス名
 */

interface Props {
  header?: any,
  className?: string,
  simulatorStatus?: boolean,
  isHeaderMultiLine?: boolean,
  children?: ReactChild | ReactChild[],
}

Frame.defaultProps = {
  simulatorStatus: true // デフォルトはチェックボックスにチェックを入れない
}

export function Frame(props: Props) {
  const { className, children, header, simulatorStatus = false, isHeaderMultiLine = false } = props

//ここから追加
  const router = useRouter()
  const query = router.query

  function link() {
    return (
      <>
        <a
          href="https://test-01.blcloud.jp/pr/assets/pdf/pack_option.pdf"
          target="_blank"
          rel="noreferrer"
          className={"text-link"}
        >パックごとの違いを見る</a><br />
      </>
    )
  }

//ここまで追加
  return (
    <div className="main-area">
      {header && (<div
        className={`store-name-area ${query.page !== "estimate" && "d-flex"} ${isHeaderMultiLine ? "flex-column" : "align-items-center"} ${simulatorStatus ? "" : "incomplete"}`}>
        {header}
        {query.page === "estimate" && <div className={"notice"} style={{ paddingLeft: 32 }}>2店舗目以降は、追加する店舗ごとに組織管理
          ¥600(税抜)が別途かかります。</div>}
      </div>)}
      <div className={className}>
        {children}
      </div>
      {[PageKey.BasicPack, PageKey.AddPack].includes(query.page as any) && (
        <div style={{ textAlign: "left", marginLeft: "50px", marginBottom: "10px" }}>
          {link()}
        </div>)}
    </div>
  )
}
